function getCartUrl() {
  if (
    !window.location.host.includes('localhost') ||
    window.location.pathname.includes('editor')
  ) {
    return '/cart/'
  } else {
    return 'http://localhost:8081/'
  }
}

function getAPIEndpoint() {
  if (window.location.host.includes('localhost')) {
    // replace this with dev backend as needed
    // return 'http://localhost:3000/'
    return 'https://backend.dev.heurekaprints.de/'
    // return 'https://backend.heurekaprints.de/'
  }
  // FIXME: why would that be needed?
  if (window.location.host.includes('yoursky.space')) {
    return 'https://backend.dev.heurekaprints.de/'
  }
  return '/backend/' //'https://backend.heurekaprints.de/'
}

function getSmosterPlayerUrl() {
  if (
    window.location.host.includes('localhost') |
    window.location.host.includes('develop')
  ) {
    return `https://develop.myvoiceposter.de/listen`
    // return 'http://localhost:8081/listen'
  }
  return `https://myvoiceposter.de/listen`
}
const backendUrl = getAPIEndpoint()
const cartUrl = getCartUrl()
const smosterPlayerUrl = getSmosterPlayerUrl()

export { backendUrl, cartUrl, smosterPlayerUrl }
